module.exports = __webpack_public_path__ + "static/media/Home.20b7850b.png";